import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import apiCall from "../../API/API";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const RoleSettings = () => {
  const [selectRole, setSelectRole] = useState("admin");
  const [routesData, setRoutesData] = useState();
  const navigate = useNavigate();

  const fetchRoutes = async () => {
    try {
      console.log("selectRole", selectRole);
      const { data, error } = await apiCall(
        "GET",
        `/get-routes-by-role?role=${selectRole}`
      );
      if (data) {
        console.log("routes data------------------", data?.routes);
        setRoutesData(data?.routes);
      }
    } catch (e) {
      toast.error(e.response.data.message);
    }
  };
  var x = 0;
  useEffect(() => {
    if (x === 0) {
      fetchRoutes();
      x++;
    }
  }, [selectRole]);

  const handleEdit = (row) => {
    navigate("/dashboard/update_role_settings", { state: { role: row } });
  };

  return (
    <React.Fragment>
      <Container>
        <section id="bankForm">
          <div className="d-flex justify-content-center">
            <h2>Role Settings</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <div className="registerForm">
                    <div id="formFields">
                      <label>Role</label>
                      <select
                        value={selectRole}
                        name="selectRole"
                        onChange={(e) => setSelectRole(e.target.value)}
                        style={{ width: "100%", borderRadius: "5px" }}
                      >
                        <option value="admin">Admin</option>
                        <option value="manager">Manager</option>
                        <option value="public">Public</option>
                        <option value="user">User</option>
                      </select>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </section>
        {selectRole && (
          <div id="directIncomeDiv">
            <Row id="directTableRow" className="text-center">
              <Col md="12" className="p-0">
                <div style={{ width: "100%" }}>
                  <table>
                    <tr>
                      <th>S No.</th>
                      <th>Routes</th>
                      <th>Route For</th>
                      <th>Description</th>
                      <th>Roles</th>
                      <th>Edit</th>
                    </tr>
                    {Array.isArray(routesData) &&
                      routesData?.map((x, i) => (
                        <tr key={i}>
                          <td className="text-center">{i + 1}</td>
                          <td className="text-center">{x?.route}</td>
                          <td className="text-center">{x?.routeFor}</td>
                          <td className="text-center">{x?.description}</td>
                          <td className="text-center">
                            {x?.roles?.map((row, index) => (
                              <p key={index}>{row}</p>
                            ))}
                          </td>
                          <td
                            className="text-center"
                            onClick={() => handleEdit(x)}
                          >
                            <i>
                              <FaEdit />
                            </i>
                          </td>
                        </tr>
                      ))}
                  </table>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </React.Fragment>
  );
};

export default RoleSettings;
